import api from './api';

// File uploads send the whole file: api.js' default 20s timeout is too short for
// a file of a few MB on a slow connection.
export const FILE_UPLOAD_TIMEOUT_MS = 120000;

export const listStorages = (workspaceId, botId) =>
  api.get(`/workspaces/${workspaceId}/storage/${botId}/storages`).then(r => r.data.data);

export const createStorage = (workspaceId, botId, { name, description, tags }) =>
  api.post(`/workspaces/${workspaceId}/storage/${botId}/storages`, { name, description, tags }).then(r => r.data.data);

export const updateStorage = (workspaceId, botId, storageId, { name, description, tags }) =>
  api.patch(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}`, { name, description, tags }).then(r => r.data.data);

export const deleteStorage = (workspaceId, botId, storageId) =>
  api.delete(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}`);

export const listFiles = (workspaceId, botId, storageId) =>
  api.get(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}/files`).then(r => r.data.data);

export const uploadFile = (workspaceId, botId, storageId, formData) =>
  api.post(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: FILE_UPLOAD_TIMEOUT_MS,
  }).then(r => r.data.data);

export const deleteFile = (workspaceId, botId, storageId, fileId) =>
  api.delete(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}/files/${fileId}`);

export const getDownloadUrl = (workspaceId, botId, storageId, fileId) =>
  api.get(`/workspaces/${workspaceId}/storage/${botId}/storages/${storageId}/files/${fileId}/download`).then(r => r.data.data.url);
